





















import { computed, defineComponent, ref } from "@vue/composition-api";
import { countryList } from "@/lib/countryList";
import { $t } from "@/lib/i18nHelpers";
import { ofacCountries } from "@/payments/components/BillingDetailsForm/ofacCountriesList";
import usStatesList from "@/payments/components/BillingDetailsForm/us-states";
import { FormFields, FormValues } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseForm from "@/components/BaseForm";

export default defineComponent({
  name: "BoletoEditView",
  components: { BaseForm, BaseButton },
  props: {
    processing: { type: Boolean, required: true, default: false },
    invoiceUrl: { type: String, required: true, default: false },
  },
  setup(_, { emit }) {
    const valid = ref<boolean>(false);
    const validate = ref<() => Promise<void>>(async () => {});

    const show = ref(false);
    const values = ref<FormValues>({
      firstName: "",
      lastName: "",
      country: countryList[0].code,
      address: "",
      houseNumber: "",
      city: "",
      state: "",
      zip: "",
      cpf: "",
    });

    const fields = computed<FormFields>(() => [
      {
        name: "firstName",
        label: $t("First name"),
        rules: ["required"],
      },
      {
        name: "lastName",
        label: $t("Last name"),
        rules: ["required"],
      },
      {
        name: "country",
        label: $t("Country"),
        type: "select",
        options: countryList
          .filter(i => ofacCountries.indexOf(i.name) === -1)
          .map(i => ({ value: i.code, text: $t(i.name) })),
      },
      {
        name: "address",
        label: $t("Address"),
        rules: ["required"],
      },
      {
        name: "houseNumber",
        label: $t("House number"),
        rules: ["required"],
      },
      {
        name: "city",
        label: $t("City"),
        rules: ["required"],
      },
      {
        name: "state",
        label: $t("State"),
        options: [
          { value: undefined, text: $t("Select state"), disabled: true },
          ...usStatesList.map(i => ({ value: i.stusab, text: i.state_name })),
        ],
        type: values.value["country"] === "US" ? "select" : undefined,
        rules: ["required"],
      },
      {
        name: "zip",
        label: $t("Zip code"),
        rules: ["required"],
      },
      {
        name: "cpf",
        label: $t("Cpf code"),
        rules: ["required"],
      },
    ]);

    const onFormInput = (v: FormValues) => {
      if ([values.value["country"], v["country"]].some(i => i === "US") && values.value["country"] !== v["country"]) {
        emit("input", {
          ...v,
          state: undefined,
        });
      } else {
        emit("input", v);
      }
    };

    const onSubmit = async () => {
      await validate.value();
      if (!valid.value) {
        return;
      }
      emit("submit", values.value);
    };

    return {
      show,
      fields,
      onFormInput,
      values,
      onSubmit,
      valid,
      validate,
    };
  },
});
